import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import { useNavigate } from "react-router-dom";
export default function MenuItems({ item, index, setOpen }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    setOpen(false);
  };
  return (
    <Box
      onClick={() => handleNavigation(item?.path)}
      sx={{
        // width: "100%",
        mx: "auto",
        position: "relative",
        cursor: "pointer",
        opacity: 0,
        transform: "translateY(30px)",
        animation: `menuItemAnimation 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1) forwards`,
        animationDelay: `${index * 0.1}s`,
        // backdropFilter: "blur(10px)",
        "@keyframes menuItemAnimation": {
          to: {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          borderRadius: "20px",
          px: { xs: 3, exl: 4 },
          py: { xs: 2.5, exl: 3 },

          background: "rgba(255,255,255,0.04)",

          border: "1px solid rgba(255,255,255,0.06)",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",

          transition: "all 0.35s cubic-bezier(0.2, 0.9, 0.4, 1.1)",

          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(circle at 50% 0%, rgba(255,255,255,0.1), transparent 70%)",
            opacity: 0,
            transition: "0.4s",
          },

          "&:hover": {
            transform: "translateY(-4px)",
            background: "rgba(255,255,255,0.07)",
            border: "1px solid rgba(255,255,255,0.12)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
          },

          "&:hover::before": {
            opacity: 0.6,
          },

          "&:hover .menu-title": {
            transform: "translateX(4px)",
            color: "secondary.main",
          },

          "&:hover .menu-arrow": {
            transform: "translateX(4px)",
            opacity: 1,
            backgroundColor: alpha(theme.palette.secondary.main, 0.2),
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2.5}
        >
          <Box
            className="menu-arrow"
            sx={{
              minWidth: 36,
              width: 36,
              height: 36,
              borderRadius: "8px", // مربعی با گوشه گرد به جای دایره
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              backdropFilter: "blur(8px)",

              transition: "all 0.3s ease",
              opacity: 0.6,
            }}
          >
            <ArrowOutwardRoundedIcon
              sx={{
                color: "#fff",
                fontSize: 22,
              }}
            />
          </Box>

          <Stack sx={{ alignItems: "end" , width:"calc(100% - 36px - 20px)" }} gap={0.5} flex={1}>
            <Typography
              className="menu-title"
              sx={{
                fontSize: { xs: "1.3rem", exl: "1.5rem" },
                fontWeight: 600,
                color: "#fff",
                letterSpacing: "-0.3px",
                transition: "0.25s ease",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width:"100%",
                direction:"rtl"
              }}
            >
              {item?.name}
            </Typography>

            <Typography
              sx={{
                color: "rgba(255,255,255,0.55)",
                fontSize: { xs: "0.8rem", exl: "0.85rem" },
                lineHeight: 1.6,
                maxWidth: "480px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width:"100%",
                direction:"rtl"
              }}
            >
              {item?.description}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
